<!-- Wird von Rossmann und FYVE im AKT. Summary benutzt-->
<!-- Wird von Lidl im AKT. Success eingebunden-->
<template>
  <div class="personal-ident-data summary-content">
    <slot name="beforePersonalIdentData"></slot>
    <b-row class="nationality">
      <b-col md="" sm="12" class="label">
        <slot name="lblNationality">Staatsangehörigkeit:</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{identificationFull.nationality.name}}</b-col>
    </b-row>
    <b-row class="ident-card">
      <b-col md="" sm="12" class="label">
        <slot name="lblIdentCard">Ausweistyp:</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{identificationFull.identCard.name}}</b-col>
    </b-row>
    <b-row class="ident-type">
      <b-col md="" sm="12" class="label">
        <slot name="lblIdentType">Ident-Verfahren:</slot>
      </b-col>
      <b-col md="" sm="12" class="value">
        <slot :name="`txtIdentType${identificationFull.identType}`">{{identificationFull.identType}}</slot>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { BCol, BRow } from 'bootstrap-vue'

export default {
  name: 'PersonalDataIdentSummary',
  components: { BRow, BCol },
  computed: {
    ...mapGetters('activation/personalData', [
      'identificationFull'
    ])
  }
}
</script>
